import api from '@/api';
import ActionStatus from '@/services/Action/ActionStatus';

class UserGridOptions {

  /**
   * Get Grid option names
   */
  static getGridOptionNamesState() {
    const namesJson = {};
    const statuses = ActionStatus.getAllStatus();

    // Get statuses, starting with actions
    let names = statuses;
    names.push('actions');

    const clientActionStatusNames = statuses.map(status => 'client-' + status);
    names = names.concat(clientActionStatusNames);
    names.push('client-actions');
    names.push('client-assets-properties');
    names.push('property-assets');

    // Now do properties
    names.push('properties');
    names.push('new-and-renewals');
    names.push('jobs');
    names.push('job-requests');
    names.push('file-sharing');
    names.push('hand-ins');
    names.push('property-action-grid');
    names.push('property-client-action-grid');

    names.forEach((name) => {
      namesJson[name] = {
        grid: {
          state: null,
          filters: null,
          sort: null,
        },
        external: {
          filters: null,
        },
      };
    });

    return namesJson;
  }

  /**
   * @param params
   */
  static saveState(params) {
    return api.post('/auth/grid', params);
  }

  /**
   *
   */
  static getState(clientId) {
    return api.get('/auth/grid?clientId=' + clientId);
  }
}

export default UserGridOptions;


